// Small uppercase mono micro-label. Used in section headers and the top
// chrome of the sidebar.

import * as React from "react";

export function Slash({ children }: { children: React.ReactNode }) {
  return (
    <span
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: 10,
        color: "var(--ink-3)",
        letterSpacing: "0.1em",
        textTransform: "uppercase",
        fontWeight: 700,
      }}
    >
      {children}
    </span>
  );
}
